var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-collapsible-container c-collapsible-content",
      attrs: {
        "aria-label":
          "" +
          (this.isOpen
            ? "Close " + this.content.title
            : "Show " + this.content.title)
      }
    },
    [
      _c(
        "button",
        {
          staticClass: "c-button c-button--neutral",
          attrs: {
            type: "button",
            "aria-label":
              "" +
              (this.isOpen
                ? "Close " + this.content.title
                : "Show " + this.content.title)
          },
          on: {
            click: function($event) {
              _vm.isOpen = !_vm.isOpen
            }
          }
        },
        [
          _c(
            "svg",
            {
              class:
                "" +
                (this.isOpen
                  ? "c-collapsible-content--open"
                  : "c-collapsible-content--closed"),
              attrs: { "aria-hidden": "true", focusable: "false" }
            },
            [
              _c("use", {
                attrs: {
                  "xmlns:xlink": "http://www.w3.org/1999/xlink",
                  "xlink:href": "#chevron-right-circle"
                }
              })
            ]
          ),
          _vm._v("\n    " + _vm._s(_vm.content.title) + "\n  ")
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.contentClass,
          attrs: {
            "aria-expanded": _vm.isOpen,
            "aria-hidden": !_vm.isOpen,
            role: "region",
            "aria-label": _vm.content.title
          }
        },
        [
          _vm.showVideo
            ? _c("div", { staticClass: "c-video-container__wrapper" }, [
                _c("iframe", {
                  staticClass: "c-video-container__iframe",
                  attrs: {
                    src: _vm.content.url,
                    frameborder: "0",
                    allowfullscreen: ""
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.showImage
            ? _c("img", {
                staticClass: "c-collapsible-content__expandable-image",
                attrs: { src: _vm.content.url, alt: _vm.content.alt },
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.expandImage = true
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showRichText
            ? _c("div", { domProps: { innerHTML: _vm._s(_vm.content.text) } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "Modal",
            {
              attrs: {
                title: _vm.content.alt,
                isVisible: _vm.expandImage,
                closeButton: true
              },
              on: { close: _vm.closeExpandedImage }
            },
            [
              _c("img", {
                staticClass:
                  "c-collapsible-content__expandable-image--expanded",
                attrs: { src: _vm.content.url, alt: _vm.content.alt }
              })
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08163db4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08163db4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/_contact-us-rap/_vue/CollapsibleContent.vue
// module id = 747
// module chunks = 0